import { render } from "./PrimaryButton.vue?vue&type=template&id=ab4a1a00&scoped=true&ts=true"
import script from "./PrimaryButton.vue?vue&type=script&lang=ts"
export * from "./PrimaryButton.vue?vue&type=script&lang=ts"

import "./PrimaryButton.vue?vue&type=style&index=0&id=ab4a1a00&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab4a1a00"]])

export default __exports__